import React, { useEffect, useState, CSSProperties } from 'react'
import { useTranslation } from 'react-i18next';

// @import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
// @end

// @import services
import RegionalService from 'app_services/admin/regional/regionalService'
import CityService from 'app_services/admin/city/cityService'
// @end

import './FilterCourses.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { CourseSchedulingModes } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes';

interface IFilterCoursesProps {
  listOfCourseModes: any[]
  className?: string
  style?: CSSProperties
  formHook?: any
  clearForm: any
  onFilterChange: (params: any) => void
}

const FilterCourses: React.FC<IFilterCoursesProps> = (props) => {

  const cityService: CityService = new CityService()
  const regionalService: RegionalService = new RegionalService()

  const [listOfRegionals, setListOfRegionals] = useState<Array<any>>([])
  const [listOfCities, setListOfCities] = useState<Array<any>>([])

  const {t} = useTranslation()

  useEffect(() => {
    getCities()
    getRegionals()
  }, [])

  const getCities = async () => {
    const items: Array<any> = []
    const response = await cityService.listExternal()
    if (response?.cities) {
      response.cities.map((item: any) => {
       items.push({ value: item._id, label: item.name })
      })
    }
    setListOfCities(items)
  }

  const getRegionals = async () => {
    const regionals: Array<any> = []
    const regionalResponse = await regionalService.listExternal()
    if (regionalResponse?.regionals) {
      regionalResponse.regionals.map((regional: any) => {
        regionals.push({ value: regional._id, label: regional.name })
      })
    }
    setListOfRegionals(regionals)
  }

  const clearFilter = () => {
    props.formHook.setValue('city', null)
    props.formHook.setValue('regional', null)
    props.clearForm()
  }

  return(
    <div
      className={`filter_courses-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <span className={'filter'}>{t('modules.academic_offer.filter.title')}</span>
      <div className={'filters'}>
        <form onSubmit={props.formHook.handleSubmit(props.onFilterChange)}>
          <TextComponent
            marginBottom='10px'
            fontWeight={600}
          >
            Modalidad
          </TextComponent>
          {props.listOfCourseModes
          ?.filter((mode) => mode.label !== CourseSchedulingModes.ON_SITE_ON_LINE)
          ?.map((mode) => (
            <label className={"content-input"} key={mode.value}>
              <input
                type="checkbox"
                name="mode"
                ref={props.formHook.register()}
                value={mode.value}
              />
              {mode.label}<i></i>
            </label>
          ))}
          <br/>
          <TextComponent
            marginBottom='10px'
            fontWeight={600}
          >
            Forma de pago
          </TextComponent>
          {/* <label className={"content-input"}>
            <input
              type="checkbox"
              name="price"
              ref={props.formHook.register()}
              value="free"
            />
            Curso gratuito<i></i>
          </label> */}
          <label className={"content-input"}>
            <input
              type="checkbox"
              name="price"
              ref={props.formHook.register()}
              value="mooc"
            />
            Mooc - Gratuito<i></i>
          </label>
          <label className={"content-input"}>
            <input
              type="checkbox"
              name="price"
              ref={props.formHook.register()}
              value="pay"
            />
            {t('modules.academic_offer.filter.pay')}<i></i>
          </label>
          <label className={"content-input"}>
            <input
              type="checkbox"
              name="price"
              ref={props.formHook.register()}
              value="discount"
            />
            {t('modules.academic_offer.filter.discount')}<i></i>
          </label>
          <br />

          <div className="form-group">
            <ReactSelectComponent
              identifier='city'
              options={listOfCities}
              formHooks={props.formHook}
              defaultValue={[]}
              isMulti={false}
              required={false}
              placeholder={t('modules.academic_offer.filter.city')}
            />
          </div>
          <div className="form-group">
            <button className='Atomboton' type="submit">{t('modules.academic_offer.filter.button')}</button>
            &nbsp;&nbsp;
            <button className='clear-form' type="button" onClick={clearFilter} >{t('modules.academic_offer.filter.clear')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FilterCourses;
